/* ==========================================================
   wwjf2026-multi-modal.js
   WWJF 3商品専用モーダル
   ========================================================== */

(function () {
  function getItem(id) {
    return (window.WWJF_DB && window.WWJF_DB[id]) ||
      (window.db && window.db[id]) ||
      null;
  }

  function getCatalogItem(id) {
    return (window.WWJF_CATALOG_PRODUCTS || []).find(function (item) {
      return item.id === id;
    });
  }

  function formatPrice(value) {
    var number = Number(String(value || '').replace(/[^0-9]/g, ''));
    return number ? '¥' + number.toLocaleString('ja-JP') : '';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      var entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return entities[char];
    });
  }

  function getValidItems(item) {
    if (!item || !Array.isArray(item.modalItems)) return [];

    return item.modalItems.filter(function (modalItem) {
      return modalItem && (
        String(modalItem.code || '').trim() ||
        String(modalItem.price || '').trim() ||
        String(modalItem.spec || '').trim()
      );
    });
  }

  function updateLikeState(id) {
    var modalLike = document.getElementById('wwjfMultiModalLike');
    if (!modalLike) return;

    var cardLike = document.querySelector('.like-btn[onclick*="' + id + '"]');
    modalLike.classList.toggle(
      'is-liked',
      Boolean(cardLike && cardLike.classList.contains('is-liked'))
    );
  }

  window.openWWJFMultiModal = function (id) {
    var item = getItem(id);
    var items = getValidItems(item);

    if (!item || !items.length) return false;

    var modal = document.getElementById('wwjfMultiModal');
    var card = document.getElementById('wwjfMultiModalCard');
    var brand = document.getElementById('wwjfMultiModalBrand');
    var title = document.getElementById('wwjfMultiModalTitle');
    var image = document.getElementById('wwjfMultiModalImg');
    var itemContainer = document.getElementById('wwjfMultiModalItems');
    var note = document.getElementById('wwjfMultiModalNote');
    var badges = document.getElementById('wwjfMultiModalBadges');

    if (!modal || !card || !brand || !title || !image || !itemContainer || !note) {
      return false;
    }

    window.wwjfMultiModalId = id;
    brand.innerText = item.brand || '';
    title.innerText = item.title || '';
    image.src = item.img || '';
    image.alt = item.title || '';

    itemContainer.innerHTML = items.map(function (modalItem) {
      var code = escapeHtml(modalItem.code);
      var spec = escapeHtml(modalItem.spec);
      var price = formatPrice(modalItem.price);

      return '<div class="wwjf-multi-modal__item">' +
        (code ? '<p class="wwjf-multi-modal__item-code">' + code + '</p>' : '') +
        (spec ? '<p class="wwjf-multi-modal__item-text">' + spec + '</p>' : '') +
        (price ? '<p class="wwjf-multi-modal__item-price">' + price + '円<span>（税込）</span></p>' : '') +
        '</div>';
    }).join('');

    note.innerText = item.modalNote || '';
    note.hidden = !String(item.modalNote || '').trim();

    if (badges) {
      var catalogItem = getCatalogItem(id);
      var badgeHtml = '';

      if (catalogItem && catalogItem.isNew) {
        badgeHtml += '<span class="wwjf-multi-modal__badge wwjf-multi-modal__badge--new">NEW</span>';
      }

      if (catalogItem && catalogItem.limitedText) {
        badgeHtml += '<span class="wwjf-multi-modal__badge wwjf-multi-modal__badge--limited">' +
          escapeHtml(catalogItem.limitedText) + '</span>';
      }

      badges.innerHTML = badgeHtml;
    }

    updateLikeState(id);
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    void modal.offsetWidth;
    card.classList.add('is-open');

    return true;
  };

  window.openWWJFProductModal = function (id) {
    var item = getItem(id);
    var items = getValidItems(item);

    if (items.length && typeof window.openWWJFMultiModal === 'function') {
      return window.openWWJFMultiModal(id);
    }

    if (typeof window.openWWJFDefaultProductModal === 'function') {
      return window.openWWJFDefaultProductModal(id);
    }

    return false;
  };

  window.closeWWJFMultiModal = function () {
    var modal = document.getElementById('wwjfMultiModal');
    var card = document.getElementById('wwjfMultiModalCard');

    if (card) card.classList.remove('is-open');

    setTimeout(function () {
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
      window.wwjfMultiModalId = null;
    }, 400);
  };

  window.toggleWWJFMultiLike = function (event) {
    var id = window.wwjfMultiModalId;
    if (!id) return;

    if (typeof window.toggleLike === 'function') {
      window.toggleLike(event, id);
    }

    var modalLike = document.getElementById('wwjfMultiModalLike');
    if (modalLike) modalLike.classList.toggle('is-liked');
  };

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var modal = document.getElementById('wwjfMultiModal');
    if (modal && modal.classList.contains('is-open')) {
      window.closeWWJFMultiModal();
    }
  });
})();
